import API from '../../../../API/api';
import { showAction } from '../../../actions/cross_sell_light_box_actions';
import { showAction as lockUi, hideAction as unlockUi } from '../../../actions/ui_lock_actions';

const onEULabelsClick = async (objParam) => {
  try {
    lockUi();
    const obj = { ...objParam, fromEuLabels: true };
    const lightContent = await API.GET({
      apiPath: `/tyre/${(obj.spinachId || obj.id).toLowerCase()}/eu-label/details.html`,
      data: '',
    });

    obj.lightContent = lightContent.replaceAll('data-original', 'src');
    obj.lightContent = obj.lightContent.replaceAll("data-background-image='", "style='background-image: url(");
    showAction(obj);
    unlockUi();
  } catch (err) {
    unlockUi();
  }
};

export default onEULabelsClick;
